import { render } from "./FeeCalculator.vue?vue&type=template&id=7b214590"
import script from "./FeeCalculator.vue?vue&type=script&lang=js"
export * from "./FeeCalculator.vue?vue&type=script&lang=js"
script.render = render

export default script